import MapViewPage from './mapView';

export default MapViewPage;
